module.exports = __webpack_public_path__ + "img/Army FM & Comptroller.0108494a.png";